import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Textarea,
  Select,
  useToast,
  VStack,
  Checkbox,
} from '@chakra-ui/react';
import { submitImageFlag } from '../../firebase/imageFlagging';
import { addUserCreditProfile } from '../../firebase/userCredits';
import CreditSelector from './CreditSelector';

const FlaggingModal = ({ isOpen, onClose, media }) => {
  const [flagType, setFlagType] = useState('');
  const [details, setDetails] = useState('');
  const [creditData, setCreditData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const toast = useToast();

  const handleSubmit = async () => {
    if (!flagType) {
      toast({
        title: 'Please select a reason for flagging',
        status: 'error',
        duration: 3000,
      });
      return;
    }

    setIsSubmitting(true);

    const flagData = {
      mediaId: media.id,
      siteId: media.siteId,
      type: flagType,
      details: {
        reason: details,
        ...(flagType === 'credit' && { creditData: creditData.credits }),
      },
    };

    const { success, error } = await submitImageFlag(flagData);

    if (success) {
      toast({
        title: 'Flag Submitted',
        description: 'Thank you for your feedback. The moderators will review your report.',
        status: 'success',
        duration: 5000,
      });
      onClose();
    } else {
      toast({
        title: 'Error submitting flag',
        description: error,
        status: 'error',
        duration: 5000,
      });
    }
    setIsSubmitting(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Flag Image</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4}>
            <FormControl isRequired>
              <FormLabel>Reason for Flagging</FormLabel>
              <Select
                placeholder="Select a reason"
                value={flagType}
                onChange={(e) => setFlagType(e.target.value)}
              >
                <option value="inaccurate">Inaccurate Information</option>
                <option value="inappropriate">Inappropriate Content</option>
                <option value="dmca">DMCA Takedown Request</option>
                <option value="credit">Request Credit</option>
              </Select>
            </FormControl>
            {flagType === 'credit' ? (
              <CreditSelector onCreditChange={setCreditData} />
            ) : (
              <FormControl isRequired>
                <FormLabel>Details</FormLabel>
                <Textarea
                  value={details}
                  onChange={(e) => setDetails(e.target.value)}
                  placeholder="Please provide as much detail as possible."
                />
              </FormControl>
            )}
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            colorScheme="red"
            ml={3}
            onClick={handleSubmit}
            isLoading={isSubmitting}
            disabled={flagType === 'credit' && !creditData}
          >
            Submit Flag
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default FlaggingModal;
